import { Toaster } from "components";

import { debitNoteConstants } from '../constants';

import { func_validation, func_serviceHandling } from 'functions';

import { promiseInstance_authorization } from './config';
import moment from "moment";



export const debitNoteActions = {
	getDebitNoteList,
	getAllDebitNoteList,
	postDebitNote,
	knockOffCredit,
	deleteDebitNote
};

function getDebitNoteList(pageNo, pageSize, sort, filterOptions) {
	return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid ? pageNo * pageSize : 0;

		let id = func_validation.getObjectPropertyValue(filterOptions, "id", "");
		let comId = func_validation.getObjectPropertyValue(filterOptions, "comId", "");
		let accountCode = func_validation.getObjectPropertyValue(filterOptions, "accountCode", "");
		let filterFrom = func_validation.getObjectPropertyValue(filterOptions, "filterFrom", "");
		let filterTo = func_validation.getObjectPropertyValue(filterOptions, "filterTo", "");
		let productCode = func_validation.getObjectPropertyValue(filterOptions, "productCode", "");
		let documentNo = func_validation.getObjectPropertyValue(filterOptions, "documentNo", "");
		let postStatus = func_validation.getObjectPropertyValue(filterOptions, "postStatus", "");

		let paramObj = {
			offset,
			limit: pageSize,
			sort,
			id,
			comId,
			accountCode,
			filterFrom: filterFrom.substring(0, 10), // Temporary fix
			filterTo: filterTo.substring(0, 10), // Temporary fix
			productCode,
			documentNo,
			postStatus
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/SearchDebitNote', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
	}

	function request(details) { return { type: debitNoteConstants.getDebitNoteList_request, details }; }
	function success(details) { return { type: debitNoteConstants.getDebitNoteList_success, details }; }
	function failure(error) { return { type: debitNoteConstants.getDebitNoteList_failure, error }; }
}

function getAllDebitNoteList(pageNo, pageSize, sort, filterOptions) {
	return dispatch => {
		dispatch(request());

		let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid ? pageNo * pageSize : 0;

		let paramObj = {
			offset,
			limit: 0,
			sort,
			...filterOptions,
			filterFrom: filterOptions?.filterFrom ? moment(filterOptions?.filterFrom).format("YYYY-MM-DD") : undefined, // Temporary fix
			filterTo: filterOptions?.filterTo ? moment(filterOptions?.filterTo).format("YYYY-MM-DD") : undefined, // Temporary fix
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/SearchDebitNote', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.get(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));
				})
				.finally(function () {
					// always executed
				});
		})
	}

	function request(details) { return { type: debitNoteConstants.getAllDebitNoteList_request, details }; }
	function success(details) { return { type: debitNoteConstants.getAllDebitNoteList_success, details }; }
	function failure(error) { return { type: debitNoteConstants.getAllDebitNoteList_failure, error }; }
}

function postDebitNote(id, date, accountCode) {
	return dispatch => {
		dispatch(request());

		let paramObj = {
			id,
			accountCode,
			dtDate: date,
			sendEmail: (process.env.NODE_ENV === "production")
		}

		let url = func_serviceHandling.createUrlWithParams('/Invoice/PostDebitNote', paramObj);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post(url)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully posted debit note" });
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to post debit note";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
	}

	function request(details) { return { type: debitNoteConstants.postDebitNote_request, details }; }
	function success(details) { return { type: debitNoteConstants.postDebitNote_success, details }; }
	function failure(error) { return { type: debitNoteConstants.postDebitNote_failure, error }; }
}

function knockOffCredit(id) {
	return dispatch => {
		dispatch(request());

		let id_formatted = "";
		if (func_validation.isNumberOrStringValid(id))
			id_formatted = encodeURI(id);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.post('/Invoice/ManualKnockOffCn?id=' + id_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deducted credit" });
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to knock off credit";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
	}

	function request(details) { return { type: debitNoteConstants.knockOffCredit_request, details }; }
	function success(details) { return { type: debitNoteConstants.knockOffCredit_success, details }; }
	function failure(error) { return { type: debitNoteConstants.knockOffCredit_failure, error }; }
}

function deleteDebitNote(id) {
	return dispatch => {
		dispatch(request());

		let id_formatted = "";
		if (func_validation.isNumberOrStringValid(id))
			id_formatted = encodeURI(id);

		promiseInstance_authorization(dispatch, request, (axios) => {
			axios.delete('/Invoice/DeleteDebitNote/' + id_formatted)
				.then(function (details) {
					// handle success
					dispatch(success(details));
					Toaster({ type: "success", msg: "Successfully deleted debit note" });
				})
				.catch(function (error) {
					// handle error
					dispatch(failure(error));

					let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete debit note";
					Toaster({ type: "error", msg });
				})
				.finally(function () {
					// always executed
				});
		})
	}

	function request(details) { return { type: debitNoteConstants.deleteDebitNote_request, details }; }
	function success(details) { return { type: debitNoteConstants.deleteDebitNote_success, details }; }
	function failure(error) { return { type: debitNoteConstants.deleteDebitNote_failure, error }; }
}